/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useCallback, useEffect, useState } from 'react';

import ICO_CLOSE from 'assets/images/close-button.svg';
import { useTranslation } from 'providers/GILT.provider';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import ConfirmationModal from 'common/ConfirmationModal';
import DropdownInlineContainer from 'onboarding/common/DropdownInline';

const InlineAlert = ({ onClose, children }) => (
  <div className="alert success animated fadeInDown" style={{ marginRight: 0 }}>
    {children}
    {onClose && (
      <span className="close" onClick={onClose}>
        <img src={ICO_CLOSE} alt="Close alert" />
      </span>
    )}
  </div>
);

const RoleField = ({ id, roleName, isSaved = false, onEditHandler = alwaysNoop, onDeleteHandler, errorMessage = '', deleteError = '' }) => {
  const [dropdownModal, setDropdownModal] = useState(false);
  const [deletePopupModal, setDeletePopupModal] = useState(false);
  const [alert, setAlert] = useState(false);
  const [localDeleteError, setLocalDeleteError] = useState('');

  const { t } = useTranslation();

  useEffect(() => {
    if (deleteError) {
      setLocalDeleteError(deleteError);
    }
  }, [deleteError]);

  const onEdit = useCallback(
    (e) => {
      e.stopPropagation();
      onEditHandler(roleName, id);
      setDropdownModal(false);
    },
    [id, roleName, onEditHandler],
  );

  const onDelete = useCallback((e) => {
    e.stopPropagation();
    setDeletePopupModal(true);
    setDropdownModal(false);
  }, []);

  const onConfirmDelete = useCallback(() => {
    onDeleteHandler(id);
    setDeletePopupModal(false);
    setAlert(true);
  }, [id, onDeleteHandler]);

  const onCancelDelete = useCallback(() => {
    setDeletePopupModal(false);
  }, []);

  const closeAlert = useCallback(() => {
    setAlert(false);
    setLocalDeleteError('');
  }, []);

  return (
    <div>
      {deletePopupModal && (
        <ConfirmationModal
          popupTitle={t('composite.rolesScreen.roleFieldConfirmationModal.title')}
          popupMessage={t('composite.rolesScreen.roleFieldConfirmationModal.popupMessage', { role: roleName })}
          leftButtonText={t('common.buttons.no')}
          rightButtonText={t('common.buttons.yes')}
          leftButtonCallback={onCancelDelete}
          rightButtonCallback={onConfirmDelete}
        />
      )}

      {alert && !localDeleteError && <InlineAlert onClose={closeAlert}>{t('composite.rolesScreen.alertMessage1', { role: roleName })}</InlineAlert>}

      <div className="rounded-border-wrap dashed">
        {isSaved && <InlineAlert onClose={closeAlert}>{t('composite.rolesScreen.alertMessage2', { role: roleName })}</InlineAlert>}

        <div className="rounded-list-item two-items" onClick={onEdit}>
          <div className="item-edit-delete">{roleName}</div>

          <div className="inline-menu-container">
            <DropdownInlineContainer
              selections={[
                { text: t('composite.rolesScreen.dropdownSelectionText1'), callback: onEdit },
                { text: t('composite.rolesScreen.dropdownSelectionText2'), callback: onDelete },
              ]}
              dropdownModal={dropdownModal}
            />
          </div>
        </div>

        {errorMessage && <InlineAlert onClose={closeAlert}>{errorMessage}</InlineAlert>}
      </div>
    </div>
  );
};

export default RoleField;
